import { SliceStylesDefaultValues } from 'extensions/core/slice-base/models/slice-base.settings.model';
import { initialSliceSlotState } from 'extensions/core/slice-base/models/slice-slot.settings.model';
import { CmsComponentGroups, IdtComponentCmsDefinition } from 'shared/idt-components/idt-components-cms.model';
import { IdtComponentRole } from 'shared/models/idt-components/idt-component-role.models';
import { IdtComponentDefinition } from 'shared/models/idt-components/idt-component.models';

import { SliceDragSettings } from 'extensions/st/slice-drag/front/settings/slice-drag-settings.model';


export const SliceDragDefinition: IdtComponentDefinition = {
  id: 'slice-drag',
  role: IdtComponentRole.Slice,
  numSlots: 1,
  defaultSlot: 1
};

export const SliceDragCmsDefinition: IdtComponentCmsDefinition = {
  name: 'Drag',
  group: CmsComponentGroups.Components,
  availablePlatforms: ['web', 'apps'],
  isNew: true,
  initialSettings: (): SliceDragSettings => {
    return {
      general: {
        alignContent: 'stretch',
        alignItems: 'flex-start',
        closeSection: false,
        closeSectionType: 'icon',
        closeSectionPosition: 'right',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        justifyContent: 'center',
        keepCloseSection: false,
        enableDragAndDrop: true,
        numSlots: 1,
        callApiCloseSection: false
      },
      slots: [
        { ...initialSliceSlotState }
      ],
      styles: SliceStylesDefaultValues
    };
  }
};
